<template>
  <a-modal
    ref="createModal"
    title="计划数量"
    :width="1000"
    :visible="visible"
    :maskClosable="false"
    @cancel="close"
    @ok="close"
    :confirmLoading="confirmLoading"
  >
    <!-- <div class="table-page-operator-wrapper">
      <a-button @click="addLine()" type="primary">新增行</a-button>
    </div> -->
    <a-form layout="inline" :labelCol="{ style: { width: '100px' } }">
      <a-row>
        <a-col :md="10" :sm="24">
          <a-form-item label="需求数量">
            <a-input :disabled="true" v-model="planQuantity"></a-input>
          </a-form-item>
        </a-col>
        <a-col :md="10" :sm="24">
          <a-form-item label="需求交期">
            <a-input :disabled="true" v-model="demandDeliveryDate"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>

    <a-table
      ref="modalTable"
      :columns="columns"
      :data-source="typeList"
      :pagination="false"
      row-key="indexId"
      :scroll="{ y: 250 }"
    >
      <!-- 单位 -->
      <!-- <span slot="unitOfMeasureTitle">
        <i class="toRequired">*</i>单位
      </span>-->

      <template slot="index" slot-scope="text, record, index">
        <span>{{ index+1 }}</span>
      </template>
      <span slot="supplierTitle">
        <i class="toRequired">*</i>供应商
      </span>
      <template slot="supplier" slot-scope="text, record">
        <!-- <a-input v-model="record.supplier" /> -->

        <!-- <global-select
          :disabled="true"
          :value.sync="record.supplier"
          selectType="selectSearch"
          requestApi="/mdm/mdmOrgSupplier/supplierNameList"
          :selectItem="{ value: 'realValue', label: 'realValue' }"
          searchParam="supplierName" /> -->
        <span >{{ record.supplier }}</span>

      </template>
      <!-- 分类 -->
      <span slot="planQuantityTitle">
        <i class="toRequired">*</i>计划数量
      </span>
      <template slot="planQuantity" slot-scope="text, record">
        <!-- <a-input-number :disabled="true" v-model="record.planQuantity" :min="0"/> -->
        <span >{{ record.planQuantity }}</span>

      </template>
      <span slot="planDeliveryDateTitle">
        <i class="toRequired">*</i>计划交期
      </span>
      <template slot="planDeliveryDate" slot-scope="text">
        <!-- <a-date-picker :disabled="true" valueFormat="YYYY-MM-DD" v-model="record.planDeliveryDate" /> -->
        <span>{{ text && $moment(text).format('YYYY/MM/DD') }}</span>

      </template>

      <!-- <template slot="planDeliveryDate" slot-scope="text, record">
        <a-select v-model="record.planDeliveryDate">
          <a-select-option v-for="(item) in baseUomFlagOptions" :key="item.dictValue">{{ item.dictLabel }}</a-select-option>
        </a-select>
      </template> -->
      <span slot="operation" slot-scope="text, record">
        <a @click="handleDelete(typeList, record)">删除</a>
      </span>
    </a-table>
  </a-modal>
</template>

<script>
import { apiscpDmQuantity, apiscpDmQuantityList } from '@/api/scp/sporadic-demand/sporadic-demand'

// 表单字段
export default {
  props: {
    uomClassOptions: {
      type: Array,
      default: () => {
        return []
      }
    },
    id: {
      type: String,
      default: () => {
        return ''
      }
    },
    planQuantity: {
      type: String,
      default: () => {
        return ''
      }
    },
    demandDeliveryDate: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  data () {
    return {
      orderId: '',
      // 状态数据字典
      baseUomFlagOptions: [
        {
          dictLabel: "是",
          dictValue: "Y"
        },
        {
          dictLabel: "否",
          dictValue: "N"
        }
      ],
      // 当前控件配置:
      confirmLoading: false,
      visible: false,
      columns: [
          {
           title: '序号',
          width: 80,
          dataIndex: 'index',
          align: 'center',
          scopedSlots: { customRender: 'index' }
        },
        {
          title: '供应商类别',
          width: 150,
          dataIndex: 'supplierClass',
          align: 'center'
        },
        {
          // title: '供应商',
          width: 150,
          dataIndex: 'supplier',
          align: 'center',
          scopedSlots: { customRender: 'supplier', title: "supplierTitle" }
        },
        {
          //  title: '计划数量',
          width: 150,
          dataIndex: 'planQuantity',
          align: 'center',
          scopedSlots: { customRender: 'planQuantity', title: "planQuantityTitle" }
        },
        {
          //  title: '计划交期',
          width: 150,
          dataIndex: 'planDeliveryDate',
          align: 'center',
          scopedSlots: { customRender: 'planDeliveryDate', title: "planDeliveryDateTitle" }
        }
        // {
        //   title: '操作',
        //   width: 100,
        //   dataIndex: 'operation',
        //   scopedSlots: { customRender: 'operation' }
        // }
      ],
      typeList: []
    }
  },
  created () {},
  methods: {
    getPageInfo () {
      apiscpDmQuantityList({ scpDmSporadicId: this.orderId }).then(response => {
        if (response.code === 200) {
          this.typeList = response.data
          let counter = 1; // 定义一个计数器从 1 开始
          this.typeList = this.typeList.map(item => {
            return { ...item, indexId: counter++ };
          });
          if (response.data.length === 0) {
            this.addLine()
          }
        } else {
          this.$message.error(response.msg)
        }
      }).catch(e => {
        this.confirmLoading = false
      })
    },
    handleDelete (arr, record) {
      arr.forEach((item, index) => {
        if (item.indexId === record.indexId) {
          arr.splice(index, 1);
        }
      });
    },
    show (orderId) {
      this.orderId = orderId;
      if (this.orderId) {
        // 加载存在的数据
        this.getPageInfo()
      } else {
        this.addLine()
      }
      this.visible = true
    },
    addLine () {
      const arr = JSON.parse(JSON.stringify(this.typeList))
      const indexId = arr.length > 0 ? arr[arr.length - 1].indexId : 0
      const obj = {
        scpDmSporadicId: this.orderId,
        supplier: '',
        planQuantity: '',
        planDeliveryDate: '',
        indexId: Number(indexId) + 1
      }
      arr.push(obj)
      this.typeList = arr
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
    },
    confirm () {
      let flag = false
      for (let i = 0; i < this.typeList.length; i++) {
        if (!this.typeList[i].supplier || !this.typeList[i].planQuantity || !this.typeList[i].planDeliveryDate) {
          this.$message.warning('必填项不能为空！')
          flag = true
          return
        }
      }
      if (flag) {
        return false
      }
      this.typeList = this.typeList.map(item => {
        const { id, ...rest } = item;
        return rest;
      });
      this.confirmLoading = true
      apiscpDmQuantity({ id: this.orderId, scpDmQuantityList: this.typeList }).then(response => {
        if (response.code === 200) {
          this.$message.success('保存成功')
          // 关闭本组件
          this.visible = false
          // 调用外部刷新列表方法
          this.$emit('handle-success')
          // 刷新表单
          this.reset()
          this.confirmLoading = false
        } else {
          this.$message.error(response.msg)
          this.confirmLoading = false
        }
      }).catch(e => {
        this.confirmLoading = false
      })
    },
    // 表单重置
    reset () {
      this.typeList = []
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-select{
  width: 150px;
}
/deep/.ant-modal-body{
  height: 400px;
  overflow-y: scroll;
}
</style>
